/* ============================================================
   Country centroids for the v2 scan-map markers, derived from the
   bundled world-atlas geometry (Natural Earth names, lowercased).
   Covers all ~177 countries so country-level signals get a dot,
   not just a hand-picked subset. Name variants GDELT uses that
   differ from Natural Earth are mapped in COUNTRY_ALIASES in
   biothreatV2Geo.ts.
   ============================================================ */
import type { LatLon } from "./biothreatV2Geo"

export const COUNTRY_CENTROIDS: Record<string, LatLon> = {
  fiji: { lon: 15.95, lat: -16.41 },
  tanzania: { lon: 34.34, lat: -6.52 },
  "w. sahara": { lon: -12.03, lat: 24.78 },
  canada: { lon: -90.74, lat: 56.4 },
  "united states of america": { lon: -90.36, lat: 38.27 },
  kazakhstan: { lon: 65.25, lat: 47.26 },
  uzbekistan: { lon: 65.29, lat: 41.15 },
  "papua new guinea": { lon: 146.21, lat: -7.77 },
  indonesia: { lon: 101.31, lat: 0.09 },
  argentina: { lon: -65.09, lat: -37.02 },
  chile: { lon: -71.42, lat: -37.96 },
  "dem. rep. congo": { lon: 23, lat: -3.84 },
  somalia: { lon: 46.84, lat: 6.42 },
  kenya: { lon: 37.82, lat: 1.11 },
  sudan: { lon: 29.34, lat: 12.81 },
  chad: { lon: 18, lat: 13 },
  haiti: { lon: -72.7, lat: 18.84 },
  "dominican rep.": { lon: -70.49, lat: 18.73 },
  russia: { lon: 77.83, lat: 59.56 },
  bahamas: { lon: -77.95, lat: 24.53 },
  "falkland is.": { lon: -59.58, lat: -51.73 },
  norway: { lon: 18.09, lat: 66.23 },
  greenland: { lon: -41.03, lat: 74.15 },
  "fr. s. antarctic lands": { lon: 69.46, lat: -49.12 },
  "timor-leste": { lon: 125.91, lat: -8.75 },
  "south africa": { lon: 24.72, lat: -28.6 },
  lesotho: { lon: 28.37, lat: -29.58 },
  mexico: { lon: -103.13, lat: 23.87 },
  uruguay: { lon: -56.14, lat: -32.7 },
  brazil: { lon: -56.93, lat: -9.66 },
  bolivia: { lon: -64.13, lat: -16.34 },
  peru: { lon: -74.08, lat: -7.75 },
  colombia: { lon: -72.65, lat: 4.49 },
  panama: { lon: -80.32, lat: 8.5 },
  "costa rica": { lon: -84.16, lat: 9.82 },
  nicaragua: { lon: -84.98, lat: 13.08 },
  honduras: { lon: -86.31, lat: 14.75 },
  "el salvador": { lon: -88.92, lat: 13.85 },
  guatemala: { lon: -90.27, lat: 15.53 },
  belize: { lon: -88.63, lat: 17.42 },
  venezuela: { lon: -66.85, lat: 7.21 },
  guyana: { lon: -58.9, lat: 4.48 },
  suriname: { lon: -55.87, lat: 3.7 },
  france: { lon: 3.3, lat: 47 },
  ecuador: { lon: -78.7, lat: -1.64 },
  "puerto rico": { lon: -66.43, lat: 18.28 },
  jamaica: { lon: -77.35, lat: 18.19 },
  cuba: { lon: -79.73, lat: 21.72 },
  zimbabwe: { lon: 29.66, lat: -18.87 },
  botswana: { lon: 24.47, lat: -22.48 },
  namibia: { lon: 17.93, lat: -21.56 },
  senegal: { lon: -14.59, lat: 13.88 },
  mali: { lon: -5.8, lat: 14.08 },
  mauritania: { lon: -12.43, lat: 18.83 },
  benin: { lon: 2.33, lat: 9.81 },
  niger: { lon: 8.74, lat: 15.48 },
  nigeria: { lon: 8.35, lat: 9.73 },
  cameroon: { lon: 13.17, lat: 6.91 },
  togo: { lon: 0.87, lat: 8.88 },
  ghana: { lon: -0.97, lat: 8.29 },
  "côte d'ivoire": { lon: -6.35, lat: 7.94 },
  guinea: { lon: -10.98, lat: 10.42 },
  "guinea-bissau": { lon: -15.21, lat: 11.98 },
  liberia: { lon: -9.14, lat: 6.75 },
  "sierra leone": { lon: -11.7, lat: 8.6 },
  "burkina faso": { lon: -1.92, lat: 12.11 },
  "central african rep.": { lon: 20.7, lat: 6.29 },
  congo: { lon: 14.93, lat: -0.92 },
  gabon: { lon: 11.89, lat: -0.34 },
  "eq. guinea": { lon: 10.07, lat: 1.59 },
  zambia: { lon: 27.98, lat: -12.83 },
  malawi: { lon: 34.06, lat: -12.91 },
  mozambique: { lon: 34.87, lat: -17.91 },
  eswatini: { lon: 31.44, lat: -26.42 },
  angola: { lon: 17.38, lat: -10.94 },
  burundi: { lon: 30.04, lat: -3.23 },
  israel: { lon: 35.19, lat: 32.06 },
  lebanon: { lon: 35.85, lat: 33.8 },
  madagascar: { lon: 46.99, lat: -17.97 },
  palestine: { lon: 35.24, lat: 31.81 },
  gambia: { lon: -15.29, lat: 13.5 },
  tunisia: { lon: 9.84, lat: 34.02 },
  algeria: { lon: 3.02, lat: 29.67 },
  jordan: { lon: 36.65, lat: 31.13 },
  "united arab emirates": { lon: 54.24, lat: 24.2 },
  qatar: { lon: 51.15, lat: 25.26 },
  kuwait: { lon: 47.74, lat: 29.34 },
  iraq: { lon: 44.4, lat: 33.44 },
  oman: { lon: 56.57, lat: 20.86 },
  vanuatu: { lon: 166.89, lat: -15.38 },
  cambodia: { lon: 104.9, lat: 12.64 },
  thailand: { lon: 100.66, lat: 13.18 },
  laos: { lon: 103.69, lat: 18.28 },
  myanmar: { lon: 97.15, lat: 20 },
  vietnam: { lon: 105.94, lat: 16.71 },
  "north korea": { lon: 127.33, lat: 39.89 },
  "south korea": { lon: 127.47, lat: 36.72 },
  mongolia: { lon: 104.59, lat: 47.2 },
  india: { lon: 83.59, lat: 23.97 },
  bangladesh: { lon: 90.61, lat: 23.4 },
  bhutan: { lon: 90.62, lat: 27.47 },
  nepal: { lon: 84.56, lat: 28.21 },
  pakistan: { lon: 69.44, lat: 30.79 },
  afghanistan: { lon: 67.77, lat: 34.83 },
  tajikistan: { lon: 70.79, lat: 38.51 },
  kyrgyzstan: { lon: 73.98, lat: 41.36 },
  turkmenistan: { lon: 58.46, lat: 39.33 },
  iran: { lon: 53.34, lat: 33.3 },
  syria: { lon: 37.95, lat: 35.15 },
  armenia: { lon: 45.31, lat: 39.95 },
  sweden: { lon: 16.56, lat: 62.74 },
  belarus: { lon: 28.22, lat: 53.38 },
  ukraine: { lon: 30.45, lat: 48.69 },
  poland: { lon: 19.48, lat: 51.74 },
  austria: { lon: 13.48, lat: 47.64 },
  hungary: { lon: 19.25, lat: 47.46 },
  moldova: { lon: 28.47, lat: 47.05 },
  romania: { lon: 25.19, lat: 45.86 },
  lithuania: { lon: 24.02, lat: 55.2 },
  latvia: { lon: 24.94, lat: 56.86 },
  estonia: { lon: 25.93, lat: 58.61 },
  germany: { lon: 10.69, lat: 51.04 },
  bulgaria: { lon: 24.69, lat: 42.89 },
  greece: { lon: 23.14, lat: 39.8 },
  turkey: { lon: 36.75, lat: 38.4 },
  albania: { lon: 20.13, lat: 41.23 },
  croatia: { lon: 16.38, lat: 44.9 },
  switzerland: { lon: 8.31, lat: 46.8 },
  luxembourg: { lon: 5.98, lat: 49.81 },
  belgium: { lon: 4.58, lat: 50.63 },
  netherlands: { lon: 5.65, lat: 52.16 },
  portugal: { lon: -8.04, lat: 39.76 },
  spain: { lon: -4.45, lat: 40.18 },
  ireland: { lon: -7.72, lat: 53.53 },
  "new caledonia": { lon: 165.51, lat: -21.18 },
  "solomon is.": { lon: 159.13, lat: -7.9 },
  "new zealand": { lon: 170.98, lat: -43.54 },
  australia: { lon: 133.25, lat: -23.8 },
  "sri lanka": { lon: 80.86, lat: 7.63 },
  china: { lon: 105.67, lat: 37.31 },
  taiwan: { lon: 121.11, lat: 23.86 },
  italy: { lon: 12.63, lat: 43.09 },
  denmark: { lon: 9.62, lat: 56.28 },
  "united kingdom": { lon: -3.08, lat: 53.9 },
  iceland: { lon: -19.27, lat: 65.28 },
  azerbaijan: { lon: 47.41, lat: 40.37 },
  georgia: { lon: 43.36, lat: 42.26 },
  philippines: { lon: 121.82, lat: 15.37 },
  malaysia: { lon: 114.77, lat: 3.68 },
  brunei: { lon: 115, lat: 4.74 },
  slovenia: { lon: 15, lat: 46.11 },
  finland: { lon: 25.77, lat: 65.48 },
  slovakia: { lon: 19.35, lat: 48.76 },
  czechia: { lon: 15.85, lat: 49.78 },
  eritrea: { lon: 39.59, lat: 14.71 },
  japan: { lon: 136, lat: 35.72 },
  paraguay: { lon: -57.57, lat: -23.3 },
  yemen: { lon: 46.47, lat: 15.51 },
  "saudi arabia": { lon: 43.59, lat: 24.04 },
  antarctica: { lon: -3.36, lat: -72.96 },
  "n. cyprus": { lon: 33.43, lat: 35.18 },
  cyprus: { lon: 33.24, lat: 35.02 },
  morocco: { lon: -9.43, lat: 28.77 },
  egypt: { lon: 31.64, lat: 28.1 },
  libya: { lon: 16.64, lat: 28.48 },
  ethiopia: { lon: 39.21, lat: 8.98 },
  djibouti: { lon: 42.52, lat: 11.8 },
  somaliland: { lon: 46.14, lat: 10.39 },
  uganda: { lon: 31.99, lat: 1.26 },
  rwanda: { lon: 29.89, lat: -1.98 },
  "bosnia and herz.": { lon: 17.87, lat: 44.15 },
  macedonia: { lon: 21.69, lat: 41.67 },
  serbia: { lon: 20.94, lat: 43.83 },
  montenegro: { lon: 19.45, lat: 42.74 },
  kosovo: { lon: 20.96, lat: 42.55 },
  "trinidad and tobago": { lon: -61.46, lat: 10.48 },
  "s. sudan": { lon: 30.09, lat: 8.01 },
}
